import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiServiceProvider } from "../api-service/api-service";

/*
  Generated class for the ActServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ActServiceProvider {
  private GEN_ACT_API: string = "genact";

  constructor(public http: HttpClient, private apiService: ApiServiceProvider) {
    console.log("Hello ActServiceProvider Provider");
  }

  async doGetPaymentRequest(pFromDate, pToDate) {
    var params = {
      fromDate: pFromDate,
      toDate: pToDate
    };
    var res: any = {};
    res = await this.apiService.get(
      this.GEN_ACT_API + "/doGetPaymentRequest",
      params
    );
    return await res.returnData;
  }

  async doApprovePaymentRequest(pData) {
    var params = pData;
    var res: any = {};
    res = await this.apiService.post(
      this.GEN_ACT_API + "/doApprovePaymentRequest",
      params
    );
    return await res.returnData;
  }

  async doRejectPaymentRequest(pData) {
    console.log(pData);
    var params = pData;
    var res: any = {};
    res = await this.apiService.post(
      this.GEN_ACT_API + "/doRejectPaymentRequest",
      params
    );
    return await res.returnData;
  }

  async doGetPurchasingRequest(pFromDate, pToDate) {
    var params = {
      fromDate: pFromDate,
      toDate: pToDate
    };
    var res: any = {};
    res = await this.apiService.get(
      this.GEN_ACT_API + "/doGetPurchasingRequest",
      params
    );
    return await res.returnData;
  }

  async doApprovePurchasingRequest(pData) {
    var params = pData;
    var res: any = {};
    res = await this.apiService.post(
      this.GEN_ACT_API + "/doApprovePurchasingRequest",
      params
    );
    return await res.returnData;
  }

  async doRejectPurchasingRequest(pData) {
    var params = pData;
    var res: any = {};
    res = await this.apiService.post(
      this.GEN_ACT_API + "/doRejectPurchasingRequest",
      params
    );
    return await res.returnData;
  }

  async doGetPaymentRequestAcceptance(pFromDate, pToDate) {
    var params = {
      fromDate: pFromDate,
      toDate: pToDate
    };
    var res: any = {};
    res = await this.apiService.get(
      this.GEN_ACT_API + "/doGetPaymentRequestAcceptance",
      params
    );
    return await res.returnData;
  }

  async doApprovePaymentRequestAcceptance(pData) {
    var params = pData;
    var res: any = {};
    res = await this.apiService.post(
      this.GEN_ACT_API + "/doApprovePaymentRequestAcceptance",
      params
    );
    return await res.returnData;
  }

  async doRejectPaymentRequestAcceptance(pData) {
    console.log(pData);
    var params = pData;
    var res: any = {};
    res = await this.apiService.post(
      this.GEN_ACT_API + "/doRejectPaymentRequestAcceptance",
      params
    );
    return await res.returnData;
  }
}



// WEBPACK FOOTER //
// ./src/providers/act-service/act-service.ts